import "./style.css";

const NotificationsPage = () => {
    return <>
        All notifications here
    </>
}

export default NotificationsPage;
